import * as amplitude from "@amplitude/analytics-browser";
import { getAcceptanceState } from "./CookiesNotice";

export function SafeAmplitude() {
    return getAcceptanceState() === true ? amplitude : null;
}

// Consent management

export function onConsentChange(accepted) {
    if (accepted) {
        SafeEnableAllAnalytics();
        UpdateClarityConsent(true);
        SafeAmplitude()?.track('Cookies Accepted');
    } else {
        UpdateClarityConsent(false);
        SafeAmplitude()?.track('Cookies Rejected');
        DisableAllAnalytics();
    }
}

// Safe initializers - only run if cookies accepted

export function SafeInitializeClarity() {
    //if ( getAcceptanceState() === true ) {
        InitializeClarity();
    //}
}

export function SafeInitializeAmplitude() {
    if ( getAcceptanceState() === true ) {
        InitializeAmplitude();
    }
}

export function SafeEnableAllAnalytics() {
    if ( getAcceptanceState() === true ) {
        InitializeClarity();
        InitializeAmplitude();
    }
}

export function DisableAllAnalytics() {
    DeinitializeAmplitude();
}


// Actual initializers

export function InitializeClarity() {
    if (typeof document !== 'undefined') {
        if (!document.getElementById('clarity-script')) {
            const script = document.createElement('script');
            script.id = 'clarity-script';
            script.type = 'text/javascript';
            script.async = false;
            script.src = '/scripts/clarity.js';
            document.head.appendChild(script);
        }
    }
}

export function UpdateClarityConsent(confirmed) {
    window.clarity('consentv2',{
        ad_Storage: confirmed ? "granted" : "denied",
        analytics_Storage: confirmed ? "granted" : "denied"
    });
}



export function InitializeAmplitude() {
    amplitude.init('21131fa5630805cd12d35960627b1764', {"autocapture":true});   
}

// Actual deinitializers

export function DeinitializeAmplitude() {
    amplitude.reset();
}